import { type } from "arktype";

export const authForgotPasswordSchema = type({
	email: type("string.email").configure({
		message: (ctx) =>
			ctx.data ? "The email address is invalid." : "The email address is required.",
	}),
});

export type AuthForgotPasswordInput = typeof authForgotPasswordSchema.infer;
